const initualState = {
    Total_Number_Of_Accounts: "",
    Total_Number_Of_Funded_Accounts: "",
    Total_Number_Of_UnFunded_Accounts: "",
    Total_Account_Balance: "",
    Total_Units: ""
  };
  
  export default (state = initualState, action) => {
    switch (action.type) {
      case "GET_STAFF_DATA":
        return { ...state, staffData: action.payload };
      default:
        return state;
    }
  };
  